import React from "react";
import PropTypes from "prop-types";

/**
 * Componente DropdownButton
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro do botão suspenso.
 * @param {Function} props.onClick - A função a ser chamada quando o botão suspenso é clicado.
 * @param {string} props.icon - O ícone a ser renderizado dentro do botão suspenso.
 * @param {("primary"|"secondary"|"success"|"danger"|"warning"|"info"|"light"|"dark"|"orange")} props.color - A cor do ícone. Deve ser um de ["primary", "secondary", "success", "danger", "warning", "info", "light", "dark", "orange"].
 * @param {string} [props.additionalClasses=""] - Classes Bootstrap adicionais a serem aplicadas ao botão suspenso.
 * @returns {ReactElement} O elemento React renderizado que representa o botão suspenso.
 */
function DropdownButton({
  children,
  onClick,
  icon,
  color,
  additionalClasses = "",
}) {
  return (
    <button onClick={onClick} className={`dropdown-item ${additionalClasses}`}>
      <div className="row">
        <div className="col-md-2">
          <i
            className={`${icon} font-size-16 text-${color} font-size-18 me-1`}
          ></i>
        </div>
        <div className="col-md-9 mt-1">{children}</div>
      </div>
    </button>
  );
}

DropdownButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
    "orange",
  ]).isRequired,
  additionalClasses: PropTypes.string,
};

export default DropdownButton;
